import { CartFragment } from '../../graphql/magento'

export const testKitDelayedBilling = ({
  cart,
  isTestKitSku,
}: {
  cart: CartFragment
  isTestKitSku: (sku: string) => boolean
}): boolean => {
  return !!cart.items?.some(
    (item) => isTestKitSku(item?.product?.sku || '') && item?.prices?.price?.value === 0,
  )
}
